import { NotificationLinkType } from '../../enums';

export const notificationLinkRoutes: Record<NotificationLinkType, string> = {
  [NotificationLinkType.News]: '/news/',
  [NotificationLinkType.Event]: '/szkolenia/',
  [NotificationLinkType.Url]: '',
  [NotificationLinkType.Gamification]: '/gamification/init',
  [NotificationLinkType.GamificationNews]: '/gamification/news/',
  [NotificationLinkType.Survey]: '/formularze/',
};
